import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from "primeng/card";
import { DocumentPreviewComponent } from "../../../document-preview/document-preview.component";
import { DialogComponent } from "src/app/@core/components/ui/dialog/dialog.component";
import { IAttachment } from '../../../../../@core/models/model';
import { ButtonComponent } from '../../../../../@core/components/ui/button/button.component';
import { AssetUrlPipe } from 'src/app/@shared/pipes/asset-url.pipe';

@Component({
  selector: 'app-source-tab',
  standalone: true,
  imports: [CommonModule, CardModule, DocumentPreviewComponent, DialogComponent, ButtonComponent, AssetUrlPipe],
  templateUrl: './source-tab.component.html'
})
export class SourceTabComponent {

  @Input() sources: any[] = [];

  showDocumentPreview: boolean = false;
  selectedDocumentFile: IAttachment | null = null;
  selectedDocumentId: string = '';
  selectedFile: any = null;
  loadingAttachment: boolean = false;
  expandedSourceIndexes: { [key: string]: boolean } = {};

  truncateContent(content: string, wordLimit: number): string {
    const words = content.split(' ');
    return words.length <= wordLimit ? content : words.slice(0, wordLimit).join(' ') + '...';
  }

  toggleExpand(index: number | string): void {
    this.expandedSourceIndexes[index] = !this.expandedSourceIndexes[index];
  }

  openDocumentPreview(file: any) {
    this.selectedFile = file;
    this.selectedDocumentId = file._id;
    this.selectedDocumentFile = file.attachment as IAttachment;
    this.showDocumentPreview = true;
  }

  closeDocumentPreview() {
    this.showDocumentPreview = false;
    this.selectedFile = null;
    this.selectedDocumentFile = null;
    this.selectedDocumentId = '';
  }
}
